import Vue from 'vue'
import Form from './Form.vue'
import { responder } from './responder';

Vue.config.productionTip = false

const app = new Vue({
  render: h => h(Form, {
    ref: 'form'
  }),
}).$mount('#form')

window.addEventListener('message', responder)

window.createToken = app.$refs.form.createToken
window.removeCVV = app.$refs.form.removeCVV
window.reset = app.$refs.form.reset
window.setRawMode = app.$refs.form.setRawMode